// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"45df5692","297":"203235ae","643":"c28ce8b1"}[chunkId] + ".chunk.js";
};